module.exports = __webpack_public_path__ + "static/img/ranked_mode_title.618b9c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ranked_mode_title.png
// module id = YeBU
// module chunks = 1